import gql from 'graphql-tag'

export default gql`
  mutation confirmFulfilmentDetails($input: ConfirmFulfilmentInput!) {
    confirmFulfilmentDetails(input: $input) {
      # We don't really need any of the data from this
      # mutation but what the hey
      parcels {
        cartId
        fulfilmentType
      }
    }
  }
`
